import { render, staticRenderFns } from "./UserProjectChangesTable.vue?vue&type=template&id=15894744&"
import script from "./UserProjectChangesTable.vue?vue&type=script&lang=ts&"
export * from "./UserProjectChangesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports